var exports = {
  "um": "StickersPicker.module__searchResultsContainer___SWZvX2",
};

module.exports = exports;
